// NOTICE: KAPTION-INTEGRATION
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import AddKaptionResponsePolicy from './AddKaptionResponsePolicy.vue';
import EditKaptionResponsePolicy from './EditKaptionResponsePolicy.vue';
import KaptionSLAReports from './KaptionSLAReports.vue';

export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/kaption-response-policies'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_kaption_response_policies',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'settings_kaption_response_policies_new',
          component: AddKaptionResponsePolicy,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':policyId/edit',
          name: 'settings_kaption_response_policies_edit',
          component: EditKaptionResponsePolicy,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'reports',
          name: 'settings_kaption_response_policies_reports',
          component: KaptionSLAReports,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
